import { useTranslation } from "react-i18next";
import ImageGallery from "../../Components/image-gallery";
import InnerPageLayout from "../../Components/Layout/InnerPageLayout";
import { Card } from "react-bootstrap";


const Gallery = () => {
  const { t } = useTranslation();

  return (
    
    <InnerPageLayout>

<Card className="mb-4">
<Card.Header>{t('photo_album')}</Card.Header>
    
      <Card.Body>

      <ImageGallery />

    </Card.Body>

      
    </Card>


  
    </InnerPageLayout>
  );
};


export default Gallery;
